import { Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Select from "react-select";
import Style from "./remark_card.module.scss";
import { getPercentage } from "../../../api";
import { toast } from "react-toastify";
import debounce from "lodash/debounce";

const RemarkCard = ({
  formik,
  formData,
  itmIndex,
  disabled,
  itemID,
  certificateID,
}) => {
  const slug = sessionStorage?.getItem("slug");

  const typeObj = formData?.type?.filter(
    (item) => item?.name === formik?.values?.group[itmIndex]?.type
  );

  const handleRemoveField = (index) => {
    const data = formik?.values?.group?.filter(
      (_, itemIndex) => itemIndex !== index
    );
    formik.setFieldValue("group", data);
  };
  const handleCountChange = (e, index) => {
    if (formik?.values?.status !== 2) {
      const diamondNumber = formik?.values?.diamond_number;
      const numberOfStones = formik?.values?.number_of_stones;
  
      const hasValidDiamondNumber = diamondNumber !== "" && diamondNumber != null;
      const hasValidNumberOfStones =
        numberOfStones !== "" && numberOfStones != null;
  
      if (hasValidDiamondNumber || hasValidNumberOfStones) {
        const mainValue = hasValidDiamondNumber ? diamondNumber : numberOfStones;
  
        formik.setFieldValue(`group[${index}].count`, e.target.value);
  
        if (mainValue !== 0) {
          let tempValue = (e.target.value / mainValue) * 100;
  
          const newValue =
            isNaN(tempValue) || !isFinite(tempValue) ? "" : tempValue;
  
          const roundedValue =
            typeof newValue === "number" && !Number.isInteger(newValue)
              ? newValue.toFixed(2)
              : newValue;
  
          formik.setFieldValue(`group[${index}].percentage`, roundedValue);
        }
      } else {
        if (e.target.value.length === 1) {
          toast.warn(
            "Validation Notice: Both Diamond number and Number of stones are missing or empty."
          );
        }
        formik.setFieldValue(`group[${index}].count`, e.target.value);
      }
    }
  };
React.useEffect(() => {
  const diamondNumber = formik?.values?.diamond_number;
  const numberOfStones = formik?.values?.number_of_stones;

  // Determine valid denominator
  let denominator = null;

  if (diamondNumber !== "" && diamondNumber != null && diamondNumber !== 0) {
    denominator = diamondNumber;
  } else if (numberOfStones !== "" && numberOfStones != null && numberOfStones !== 0) {
    denominator = numberOfStones;
  }

  if (denominator != null) {
    // Valid denominator exists
    const updatedGroup = formik.values.group.map((item) => {
      const count = parseFloat(item?.count);
      if (!isNaN(count) && isFinite(count)) {
        const percentage = ((count / denominator) * 100).toFixed(2);
        return {
          ...item,
          percentage
        };
      }
      return {
        ...item,
        percentage: ""
      };
    });

    formik.setFieldValue("group", updatedGroup);
  } else {
    // No valid denominator; clear all percentages
    const clearedGroup = formik.values.group.map((item) => ({
      ...item,
      percentage: ""
    }));
    formik.setFieldValue("group", clearedGroup);
  }
}, [formik?.values?.diamond_number, formik?.values?.number_of_stones]);



  // const fetchAndSetPercentage = (countValue, index) => {
  //   if (!countValue) return;

  //   const requestData = {
  //     id: certificateID,
  //     d_no: countValue,
  //     slug: slug,
  //   };

  //   getPercentage(requestData)
  //     .then((response) => {
  //       if (response?.data?.status_code === 200) {
  //         formik.setFieldValue(
  //           `group.${index}.percentage`,
  //           response?.data?.data?.percentage
  //         );
  //       } else {
  //         toast.error(response?.data?.message ?? "Can't fetch percentage");
  //       }
  //     })
  //     .catch(() => {
  //       toast.error("Can't fetch percentage");
  //     });
  // };

  // const debouncedFetchPercentage = React.useMemo(
  //   () =>
  //     debounce((countValue, index) => {
  //       fetchAndSetPercentage(countValue, index);
  //     }, 500),
  //   [certificateID, slug]
  // );

  // React.useEffect(() => {
  //   return () => {
  //     debouncedFetchPercentage.cancel();
  //   };
  // }, [debouncedFetchPercentage]);

  return (
    <div className={Style.container} key={itmIndex}>
      {formik?.values?.group?.length !== 1 && (
        <span
          className={`${Style.corner_button} btn-close`}
          onClick={() => handleRemoveField(itmIndex)}
        ></span>
      )}

      {/* Type Field */}
      <div className="input-wrap pro-mb-4">
        <label
          htmlFor={`type${itmIndex}`}
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Type
        </label>
        <Select
          id={`type${itmIndex}`}
          name={`type${itmIndex}`}
          placeholder="Select"
          className={`pro-input lg ${
            formik.touched?.group?.[itmIndex]?.type &&
            formik.errors?.group?.[itmIndex]?.type &&
            "error"
          }`}
          classNamePrefix="pro-input"
          options={formData?.type ?? []}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?.id}
          onBlur={formik?.handleBlur(`group.${itmIndex}.type`)}
          isMulti={false}
          onChange={(value) =>
            formik?.setFieldValue(`group.${itmIndex}.type`, value?.name || "")
          }
          menuPlacement="auto"
          value={typeObj}
          isDisabled={disabled}
        />
        {formik.touched?.group?.[itmIndex]?.type &&
          formik.errors?.group?.[itmIndex]?.type && (
            <span className="error-text">
              {formik.errors?.group?.[itmIndex]?.type}
            </span>
          )}
      </div>

      {/* Others Field */}
      {formik.values?.group?.[itmIndex]?.type === "OTHERS" && (
        <Input
          label="Others"
          type="text"
          id={`others${itmIndex}`}
          name={`others${itmIndex}`}
          className={`pro-input lg ${
            formik.touched?.group?.[itmIndex]?.others &&
            formik.errors?.group?.[itmIndex]?.others &&
            "error"
          }`}
          disabled={disabled}
          onChange={(e) =>
            formik?.setFieldValue(`group.${itmIndex}.others`, e?.target?.value)
          }
          error={
            formik.touched?.group?.[itmIndex]?.others &&
            formik.errors?.group?.[itmIndex]?.others && (
              <span className="error-text">
                {formik.errors?.group?.[itmIndex]?.others}
              </span>
            )
          }
          errorMessage={
            formik.touched?.group?.[itmIndex]?.others &&
            formik.errors?.group?.[itmIndex]?.others && (
              <span className="error-text">
                {formik.errors?.group?.[itmIndex]?.others}
              </span>
            )
          }
          onBlur={formik?.handleBlur(`group.${itmIndex}.others`)}
          value={formik.values?.group?.[itmIndex]?.others}
        />
      )}

      {/* Count Field */}
      <Input
        label="Count"
        type="text"
        id={`count${itmIndex}`}
        name={`count${itmIndex}`}
        className={`pro-input lg ${
          formik.touched?.group?.[itmIndex]?.count &&
          formik.errors?.group?.[itmIndex]?.count &&
          "error"
        }`}
        disabled={disabled}
       onChange={(e) => {
          const value = e.target.value;
          if (/^\d*$/.test(value)) {
            handleCountChange(e, itmIndex);
            // debouncedFetchPercentage(value, itmIndex);
          }
        }}
        error={
          formik.touched?.group?.[itmIndex]?.count &&
          formik.errors?.group?.[itmIndex]?.count && (
            <span className="error-text">
              {formik.errors?.group?.[itmIndex]?.count}
            </span>
          )
        }
        errorMessage={
          formik.touched?.group?.[itmIndex]?.count &&
          formik.errors?.group?.[itmIndex]?.count && (
            <span className="error-text">
              {formik.errors?.group?.[itmIndex]?.count}
            </span>
          )
        }
        onBlur={formik?.handleBlur(`group.${itmIndex}.count`)}
        value={formik.values?.group?.[itmIndex]?.count}
      />

      {/* Percentage Field */}
      <Input
        label="Percentage"
        type="text"
        id={`percentage${itmIndex}`}
        name={`percentage${itmIndex}`}
        className={`pro-input lg ${
          formik.touched?.group?.[itmIndex]?.percentage &&
          formik.errors?.group?.[itmIndex]?.percentage &&
          "error"
        }`}
        disabled={disabled}
        onChange={(e) =>
          formik?.setFieldValue(
            `group.${itmIndex}.percentage`,
            e?.target?.value
          )
        }
        error={
          formik.touched?.group?.[itmIndex]?.percentage &&
          formik.errors?.group?.[itmIndex]?.percentage && (
            <span className="error-text">
              {formik.errors?.group?.[itmIndex]?.percentage}
            </span>
          )
        }
        errorMessage={
          formik.touched?.group?.[itmIndex]?.percentage &&
          formik.errors?.group?.[itmIndex]?.percentage && (
            <span className="error-text">
              {formik.errors?.group?.[itmIndex]?.percentage}
            </span>
          )
        }
        onBlur={formik?.handleBlur(`group.${itmIndex}.percentage`)}
        value={formik.values?.group?.[itmIndex]?.percentage}
      />
    </div>
  );
};

export default RemarkCard;
